import type { ReactNode } from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import type { Territoire } from "models";

interface TerritoireBoxProps {
  territoire: Territoire;
  isLoading?: boolean;
  noWrap?: boolean;
}

export function TerritoireBox({
  territoire,
  isLoading = false,
  noWrap = false,
}: Readonly<TerritoireBoxProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Typography noWrap={noWrap}>{territoire.libelle}</Typography>
    </Box>
  );
}
